module.exports = __webpack_public_path__ + "img/wishlist.70812910.png";